import Swal from "sweetalert2";
import { get_token } from "@/router";
import {
  calculate_days_left,
  donation_form_methods,
  get_campaign_cover_image,
  get_campaign_file_icon_class,
  get_campaign_file_name,
  get_campaign_file_url,
  get_campaign_supporting_files_count,
  get_campaign_raised_amount,
  get_campaign_summary,
  get_progress,
  get_progress_width,
  format_currency,
  format_date,
  format_datetime,
  get_donation_amount_value,
  is_campaign_image_file,
  is_campaign_video_file,
  is_long_campaign_description,
} from "./donation_campaigns_methods_helper";
import { donation_checkout_methods } from "./donation_campaigns_checkout_helper";
import {
  campaign_comment_methods,
  get_campaign_comments,
} from "./donation_campaigns_comments_helper";
import { format_comment_time_ago } from "./donation_campaigns_comments_display_helper";
import { campaign_data_methods } from "./donation_campaigns_data_helper";

function compare_donations(left, right, donor_sort) {
  const left_amount = Number(left?.amount || 0);
  const right_amount = Number(right?.amount || 0);

  if (donor_sort === "lowest") {
    return left_amount - right_amount;
  }

  return right_amount - left_amount;
}

export function get_selected_campaign_donations(campaign, donor_sort) {
  const donations = campaign?.donations || [];
  const completed_donations = donations.filter(
    (donation) => String(donation?.donation_status || "").toLowerCase() === "completed"
  );

  return [...completed_donations].sort((left, right) => compare_donations(left, right, donor_sort));
}

function get_request_headers() {
  return ({ Authorization: `Token ${get_token()}` });
}

function get_campaign_status_value(campaign) {
  return String(campaign?.status?.name || campaign?.status || "").trim().toLowerCase();
}

function get_campaign_creator_user_id(campaign) {
  return campaign?.created_by_profile?.user?.id || null;
}

function open_donation_warning(instance) {
  Swal.fire({
    icon: "warning",
    title: "Please sign in to donate.",
    showConfirmButton: false,
    timer: 2200,
    position: "bottom-end",
    toast: true,
  }).then(() => {
    instance.$router.push({ name: "login" });
  });
}

export const campaign_view_methods = {
  ...donation_form_methods,
  ...donation_checkout_methods,
  ...campaign_comment_methods,
  ...campaign_data_methods,
  format_comment_time_ago,
  getToken() {
    return get_token();
  },
  get_campaign_summary,
  get_campaign_raised_amount,
  get_progress_width,
  toggleSidebar() {
    return null;
  },
  get_request_headers() {
    return get_request_headers();
  },
  get_campaign_status_value,
  is_campaign_creator(campaign) {
    return Number(get_campaign_creator_user_id(campaign)) === Number(this.user_details?.user_id);
  },
  sync_page_state() {
    const campaign_id = this.$route.query.campaign_id;
    if (campaign_id) {
      this.selected_campaign_id = campaign_id;
      this.mobile_description_expanded = false;
      this.active_tab = "detail";
      this.detail_tab = "donors";
      this.reset_comment_form();
      return;
    }

    if (!["explore", "detail"].includes(this.active_tab)) {
      this.active_tab = "explore";
    }
  },
  go_to_explore_page(campaign_id = null) {
    if (campaign_id) {
      this.selected_campaign_id = campaign_id;
      this.mobile_description_expanded = false;
      this.active_tab = "detail";
      this.$router.replace({ name: "donation_campaigns", query: { campaign_id } });
      return;
    }

    this.active_tab = "explore";
    this.mobile_description_expanded = false;
    this.reset_comment_form();
    this.$router.replace({ name: "donation_campaigns" });
  },
  go_to_manage_page() {
    this.$router.push({ name: "my_donation_campaigns" });
  },
  go_to_donation_history_page() {
    this.$router.push({ name: "donation_history" });
  },
  go_to_create_campaign_page() {
    this.$router.push({ name: "my_donation_campaigns", query: { tab: "create" } });
  },
  go_to_manage_campaign_page(campaign) {
    if (!campaign?.id) {
      this.$router.push({ name: "my_donation_campaigns" });
      return;
    }

    this.$router.push({ name: "my_donation_campaigns", query: { campaign_id: campaign.id } });
  },
  open_campaign_detail(campaign) {
    if (!campaign?.id) {
      return;
    }

    this.go_to_explore_page(campaign.id);
  },
  set_detail_tab(tab) {
    this.detail_tab = tab;
  },
  set_donor_sort(sort) {
    this.donor_sort = sort;
  },
  set_donor_page(page) {
    if (page < 1 || page > this.donor_total_pages) {
      return;
    }

    this.donor_page = page;
  },
  open_donation_modal(campaign = null) {
    if (!this.token_exists) {
      open_donation_warning(this);
      return;
    }

    this.donation_campaign = campaign || this.selected_campaign || null;
    this.reset_donation_form();
    $("#donation_checkout_modal").modal("show");
  },
  open_file_preview(file) {
    this.preview_file = {
      name: this.get_campaign_file_name(file),
      url: this.get_campaign_file_url(file),
      is_image: is_campaign_image_file(file),
      is_video: is_campaign_video_file(file),
      is_pdf: String(this.get_campaign_file_url(file) || this.get_campaign_file_name(file) || "").toLowerCase().includes(".pdf"),
    };
    $("#campaign_file_preview_modal").modal("show");
  },
  clear_file_preview() {
    this.preview_file = null;
  },
  toggle_mobile_description() {
    this.mobile_description_expanded = !this.mobile_description_expanded;
  },
  is_long_campaign_description,
  format_datetime,
  get_campaign_file_created_at(file) {
    return file?.created_at || "";
  },
  is_campaign_image_file,
  is_campaign_video_file,
  get_donation_amount_value,
  calculate_days_left,
  get_campaign_cover_image,
  get_campaign_file_icon_class,
  get_campaign_file_name,
  get_campaign_file_url,
  get_campaign_supporting_files_count,
  get_progress,
  format_currency,
  format_date,
  get_campaign_comments,
};

